import { DoubleArrow } from '@mui/icons-material'
import { Container, IconButton } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { counterViewsOffer, getClientOffers } from '../../../../../redux/actions/offers'
import { IRootState } from '../../../../../redux/types'
import Header from '../../../../shared/components/Header'
import TypeFilter from '../../../../shared/components/TypeFilter'
import useSkeleton from '../../../../shared/components/layouts/SkeletonLayout'
import ContentFilter from '../../../../shared/components/layouts/filters/ContentFilter'
import HiddenDesktop from '../../../../shared/styles/HiddenDesktop'
import ScrollSubHeader from '../../../../shared/styles/ScrollSubHeader'
import SubHeader from '../../../../shared/styles/Subheader'
import OffersPanel from '../components/OffersPanel'

interface IFilter {
  type: number
}

function OffersHome() {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()

  const { globalFamilyId, globalBrandId, globalLineId, globalCountryId, globalRoleId, globalLanguageId, globalOrderById, globalTag } =
    useSelector((state: IRootState) => state.global)

  const types = [t('professional'), t('your-clients')]
  const [filters, setFilters] = useState<IFilter>({
    type: 0
  })

  useEffect(() => {
    dispatch(
      getClientOffers({
        family_id: globalFamilyId,
        brand_id: globalBrandId,
        line_id: globalLineId,
        country_id: globalCountryId,
        role_id: globalRoleId,
        language_id: globalLanguageId,
        orderby_id: globalOrderById,
        tag_id: globalTag,
        type: filters.type
      })
    )
  }, [
    dispatch,
    globalFamilyId,
    globalBrandId,
    globalLineId,
    globalCountryId,
    globalRoleId,
    globalLanguageId,
    globalOrderById,
    globalTag,
    filters.type
  ])

  const { loading: loadingSkeleton, component: componentSkeleton } = useSkeleton()

  const myElement = document.getElementById('window')
  const midOfWidth = window.innerWidth / 2

  const handleChangeFilter = (type: number) => {
    setFilters({ type })
  }

  if (loadingSkeleton) {
    return componentSkeleton
  }

  return (
    <>
      <Header title={t('offers')} />
      <SubHeader>
        <ScrollSubHeader id="window">
          {types.map((type, index) => (
            <TypeFilter
              key={type}
              id={index}
              type={type}
              categories={[]}
              active={filters.type === index}
              handleChangeFilter={handleChangeFilter}
            />
          ))}
        </ScrollSubHeader>
        <HiddenDesktop>
          <IconButton sx={{ position: 'absolute !important', right: 0, top:'17%', zIndex: 10, backgroundColor: 'white' }} className="buttonScroll" onClick={() => myElement?.scrollBy(midOfWidth, 0)}>
            <DoubleArrow />
          </IconButton>
        </HiddenDesktop>
      </SubHeader>
      <ContentFilter />

      <Container sx={{ maxWidth: '1008px' }}>
        <OffersPanel userCounterViewsOffer={counterViewsOffer} subsection={types[filters.type]} />
      </Container>
    </>
  )
}

export default OffersHome
